// @flow

import type { PropsSchema, BasicProps, EasyAction } from '../../type'

import * as React from 'react'
import css from './Folder.scss'
import cx from 'classnames'
import { onClickEvent, animation } from '../hoc'
import computeData from '../hoc/computeData'
import { getPageInfo } from '../../pageInfo'
import $ from 'jquery'

type Props = BasicProps & {
  style: { [string]: string },
  children: React.ChildrenArray<React.Node>,
  onClick: () => void,
  addAnimationEvent: any => void,
  events?: Object,
  shouldUpdate?: string,
  useSticky: boolean,
  isAutoFill: boolean,
  customProps: any
};
type State = {
  isVisualArea: boolean,
  height: number
};
@computeData()
@animation
@onClickEvent
export default class Folder extends React.Component<Props, State> {
  state = {
    isVisualArea: true,
    height: 0
  };
  scrollTimeout: any;
  scrollTimeout1: any;

  static schema: PropsSchema = [
    {
      title: '更新条件',
      key: 'shouldUpdate',
      type: 'code',
      annotation: '//可用参数：cuProps，preCuProps'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'boolean',
      key: 'useSticky',
      title: '使用Sticky'
    },
    {
      type: 'boolean',
      key: 'isAutoFill',
      title: '填充剩余高度'
    },
    'separator',
    {
      type: 'event',
      title: '就绪',
      event: 'ready'
    },
    {
      type: 'event',
      title: '获取组件当前位置后',
      event: 'getOffset'
    },
    {
      type: 'event',
      title: '滚动时',
      event: 'scrollCurrentPosition'
    },
    {
      type: 'event',
      title: '触底',
      event: 'reachBottom'
    },
    {
      type: 'event',
      title: '移出可视区域',
      event: 'moveOutVisualArea'
    },
    {
      type: 'event',
      title: '移入可视区域',
      event: 'moveInVisualArea'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '滚动到当前位置',
      name: 'toCurrentPosition',
      dataSchema: [
        {
          key: 'top',
          title: '向上偏移量',
          placeholder: '支持px 和rem'
        },
        {
          key: 'rootId',
          title: '滚动的父容器的id',
          placeholder: '不填则是rootEasyComp_comp'
        }
      ]
    },
    {
      title: '获取组件当前位置',
      name: 'getOffset',
      dataSchema: [
        {
          key: 'rootId',
          title: '滚动的父容器的id',
          placeholder: '不填则是rootEasyComp_comp'
        }
      ]
    }
  ];

  shouldComponentUpdate (nextProps: Props) {
    const { shouldUpdate, jsEnv, customProps } = nextProps
    if (shouldUpdate) {
      return jsEnv.runCodeWithAdditionalCtx(shouldUpdate, {
        cuProps: customProps,
        preCuProps: this.props.customProps
      })
    }
    return true
  }

  actionToCurrentPosition = (data?: { rootId: ?string, top?: string }) => {
    const { rootId, top } = data || {}
    const offSet = this.getOffSet(data)
    if (!offSet) {
      return
    }
    let root = $(`#${rootId || 'rootEasyComp'}_comp`)
    let pxTop = 0
    if (top && /^.+rem$/.test(top)) {
      pxTop =
        parseFloat(window.document.documentElement.style.fontSize) *
        parseFloat(top)
    } else if (top) {
      pxTop = parseFloat(top)
    }
    root
      .parent()
      .animate(
        { scrollTop: offSet.scrollTop - pxTop },
        { duration: 500, easing: 'swing' }
      )
  };

  getOffSet = (data?: { rootId: ?string }) => {
    const { id } = this.props
    const { rootId = '' } = data || {}
    const node = $(`#${id}`)
    let root = $(`#${rootId || 'rootEasyComp'}_comp`)
    const offSet = node.offset()
    if (!offSet) return
    const scrollTop = offSet.top - root.offset().top
    return {
      scrollTop,
      ...offSet
    }
  };

  actionGetOffset = (data?: { rootId: ?string }) => {
    this.props.callActions('getOffset', this.getOffSet(data))
  };

  isExistScrollCurrent () {
    const { events = {} } = this.props
    const { scrollCurrentPosition = {} } = events
    const { targets = [] } = scrollCurrentPosition
    return targets.length > 0
  }

  isExistFolderHide () {
    const { events = {} } = this.props
    const { moveOutVisualArea = {} } = events
    const { targets = [] } = moveOutVisualArea
    return targets.length > 0
  }

  isExistFolderShow () {
    const { events = {} } = this.props
    const { moveInVisualArea = {} } = events
    const { targets = [] } = moveInVisualArea
    return targets.length > 0
  }
  onScrollHandle () {
    const moveInVisualArea = this.isExistFolderShow()
    const moveOutVisualArea = this.isExistFolderHide()
    const scrollCurrent = this.isExistScrollCurrent()
    if (scrollCurrent || moveOutVisualArea || moveInVisualArea) {
      const rootElement = document.getElementById('rootEasyComp_comp') || {}
      const parentNode = rootElement.parentNode
      const { id } = this.props
      const node = window.document.getElementById(id)
      if (!node) {
        return
      }
      const scrollHeight = window.document.getElementById(id).scrollHeight
      const screenHeight = $(window).height() // 可视区域的高度
      if (parentNode) {
        parentNode.addEventListener(
          'scroll',
          () => {
            const { isVisualArea } = this.state
            if (scrollCurrent) {
              const offset = this.getOffSet()
              if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout)
              }
              this.scrollTimeout = setTimeout(() => {
                this.props.callActions('scrollCurrentPosition', offset)
              }, 30)
            } else if (moveOutVisualArea || moveInVisualArea) {
              const offsetTop = $(`#${id}`).offset().top
              if (
                !isVisualArea &&
                offsetTop + scrollHeight > 0 &&
                offsetTop - screenHeight <= 0 &&
                moveInVisualArea
              ) {
                this.props.callActions('moveInVisualArea')
                this.setState({
                  isVisualArea: true
                })
              } else if (
                isVisualArea &&
                (offsetTop + scrollHeight <= 0 ||
                  offsetTop - screenHeight > 0) &&
                moveOutVisualArea
              ) {
                this.props.callActions('moveOutVisualArea')
                this.setState({
                  isVisualArea: false
                })
              }
            }
          },
          false
        )
      }
    }
  }

  componentDidMount () {
    let { callActions, addAnimationEvent, isAutoFill } = this.props
    callActions('ready')
    if (this.refs.folder && addAnimationEvent) {
      addAnimationEvent(this.refs.folder)
    }
    this.onScrollHandle()
    //
    if (this.refs.folder && isAutoFill) {
      // 同iscroll的高度计算
      let rootElement = window.document.getElementById('rootEasyComp_comp')
      const rootParent = rootElement.parentNode
      const screenHeight =
        rootParent.scrollHeight -
        parseInt(rootParent.style.paddingTop || 0, 10) -
        parseInt(rootParent.style.paddingBottom || 0, 10)
      const contentHeight = rootElement.children[0].clientHeight || 0
      const height = screenHeight - contentHeight
      this.setState({ height })
    }
  }

  onScroll = () => {
    if (this.scrollTimeout1) {
      clearTimeout(this.scrollTimeout1)
    }
    this.scrollTimeout1 = setTimeout(() => {
      const { id } = this.props
      const scrollTop = window.document.getElementById(id).scrollTop
      const scrollHeight = window.document.getElementById(id).scrollHeight
      const clientHeight = window.document.getElementById(id).clientHeight
      if (
        scrollTop > 0 &&
        Math.abs(clientHeight + scrollTop - scrollHeight) < 2
      ) {
        this.props.callActions('reachBottom')
      }
    }, 30)
  };

  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style, children, onClick, useSticky, isAutoFill } = this.props
    let newStyle = { ...style }
    const { height } = this.state
    if (getPageInfo().platform === 'app') {
      newStyle.display = 'flex'
    }
    if (isAutoFill) {
      newStyle.height = height
    }
    return (
      <div
        className={cx(css.main, useSticky && css.useSticky)}
        style={newStyle}
        id={id}
        onScroll={this.onScroll}
        onClick={onClick}
        ref='folder'
      >
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Folder.js